<!-- 予約内容入力 -->
<template>
  <TemplateMfittBooking1 v-if="isReadyToDraw" :stations="stations" />

  <!-- 描画ローディング -->
  <DialogInitialLoading v-else :timeout-seconds="7000" />

  <!-- 電波状況が悪い場合のダイアログ　-->
  <DialogBadReception
    ref="DialogBadReception"
    :close-button-clicked="backToMfittIndexPage"
  />

  <DialogDuringMaintenance
    ref="DialogDuringMaintenance"
    :close-button-clicked="backToMfittIndexPage"
  />

  <DialogUnexpectedError
    ref="DialogUnexpectedError"
    :close-button-clicked="backToMfittIndexPage"
  />
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import TemplateMfittBooking1 from "@/views/Templates/MFITT/TemplateMfittBooking1";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "MfittBooking1",
  components: {
    TemplateMfittBooking1,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    // ログインしているかどうか
    const isLogin = store.getters["common/isLogin"];

    const isReadyToDraw = ref(false);

    const DialogBadReception = ref(null);
    const DialogUnexpectedError = ref(null);
    const DialogDuringMaintenance = ref(null);

    const stations = ref([]);

    const getCouponData = async () => {
      // 引換券使用の場合は、対象のcoupon_idをクエリに持つ
      if (route.query.coupon_id) {
        await API.getCouponWithId(route.query.coupon_id);
      } else {
        // 引換券を使用しない場合は、念の為storeをクリア。
        store.commit("MFITT/setSelectedCoupon", null);
      }
    };

    onMounted(async () => {
      if (!isLogin) {
        // 未ログインの場合はダイアログ
        nativeHandlerService.returnNativeAppToAccountPage();
        // 未ログインのダイアログは、ダイアログ外を押しても閉じてしまうので、対策として10秒後にネイティブに戻る
        setTimeout(backToMfittIndexPage, 10000);
      } else {
        try {
          stations.value = await API.getStationsForMFITT();
          await getCouponData();
          isReadyToDraw.value = true;
        } catch (e) {
          if (e.response.data.message) {
            if (e.response.data.message === "回線が込み合っています") {
              DialogBadReception.value.openDialog();
              // MWのメンテナンス中
            } else if (e.response.status == 503) {
              DialogDuringMaintenance.value.openDialog(e.response.data);
            } else {
              // nativeにエラー内容送信
              nativeHandlerService.ncSendMfittError(e.response.data.message);
              DialogUnexpectedError.value.openDialog();
            }
          } else {
            nativeHandlerService.ncSendMfittError("MFITTBooking1 onMounted()");
          }
        }
      }
    });

    const backToMfittIndexPage = () => {
      nativeHandlerService.returnNativeAppMfittIndexPage();
    };

    return {
      isReadyToDraw,
      DialogBadReception,
      DialogUnexpectedError,
      DialogDuringMaintenance,
      stations,
      backToMfittIndexPage,
    };
  },
};
</script>
